export var animatableKeys = [
    // CSS Properties
    'transform',
    'opacity',
    'fontSize',
    'backgroundColor',
    'color',
    'borderRadius',
    'boxShadow',
    // transform sub-properties
    'rotate',
    'scaleX',
    'scaleY',
    'skewX',
    'skewY',
    'translateX',
    'translateY',
];
export var fullSizeStyle = {
    position: 'absolute',
    left: '0%',
    top: '0%',
    width: '100%',
    height: '100%',
};
export var defaultStyles = {
    backgroundColor: 'rgba(0, 0, 0, 0)',
    borderRadius: '0px',
    letterSpacing: '0px',
    opacity: '1',
    overflow: '',
    padding: '0em',
    rotate: '0deg',
    scaleX: '1',
    scaleY: '1',
    skewX: '0deg',
    skewY: '0deg',
    textTransform: 'none',
    translateX: '0%',
    translateY: '0%',
};
var sharedConfig = {
    animatableKeys: animatableKeys,
    fullSizeStyle: fullSizeStyle,
};
export default sharedConfig;
